import {isHomePage} from "./functions/pages";

const PHONE_NUMBER = '0786290629';
const EMAIL = 'info@vectoreyes.nl';
const LINKEDIN = 'https://www.linkedin.com/company/vector-eyes-b.v./';

/**
 * @param {string} link
 * @param {string} className
 * @param {boolean} blank
 * @returns {HTMLAnchorElement}
 */
function createIcon(link, className, blank) {
    const icon = document.createElement('a');
    icon.setAttribute('href', link);
    icon.classList.add('icon');
    icon.classList.add(className);

    if (blank) {
        icon.setAttribute('target', '_blank');
    }

    return icon;
}

/**
 * @param {HTMLElement} element
 */
function createSocialIcons(element) {
    const icons = [];
    icons.push(createIcon(
        'tel:' + PHONE_NUMBER,
        'telephone',
        false
    ));
    icons.push(createIcon(
        'mailto:' + EMAIL,
        'mail',
        false
    ));
    icons.push(createIcon(
        LINKEDIN,
        'linkedin',
        true
    ));

    const container = document.createElement('div');
    container.classList.add('social-icons');

    // Inhoud
    icons.forEach((icon) => {
        container.appendChild(icon);
    });

    // Container toevoegen
    element.appendChild(container);
}

window.addEventListener('load', () => {
    if (!isHomePage()) {
        return;
    }
    const video = document.querySelector('video.wp-block-cover__video-background');
    if (video !== null) {
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
    }

    const container = document.querySelector('.wp-block-cover.is-style-home .wp-block-cover__inner-container');

    if (container !== null) {
        createSocialIcons(container);
    }
});